// Form Spinner Enums ----------------------------------------------------------------------------------------------------------------------

export enum FormSpinnerFields {
  Caption = "caption",
  IsActive = "isActive",
  StartTime = "startTime",
}

// Form Spinner Interface ------------------------------------------------------------------------------------------------------------------

export interface FormSpinnerRedux {
  [FormSpinnerFields.Caption]?: string | null;
  [FormSpinnerFields.IsActive]: boolean;
  [FormSpinnerFields.StartTime]?: number | null;
}
